import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'
import axios from 'axios';


function PrivacyPolicy() {
  const navigate = useNavigate()
  const [privacy, setPrivacy] = useState('')

  // const goToHomepage = () => {
  //   navigate('/', {replace: true})
  // }

  useEffect(() => {
      const getPrivacyPolicy = async () => {
        const resp = await axios.get(process.env.REACT_APP_API_URL + 'privacyPolicy')
        setPrivacy(resp?.data?.privacyPolicy ? resp.data.privacyPolicy : '')
      }

      getPrivacyPolicy()
  }, [])

  return (
    <div className="doc">
      <div style={{ whiteSpace: 'pre-wrap' }}>
        {privacy}
      </div>
    </div>
  );
}

export default PrivacyPolicy
